import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgTakeawayFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m20.106 8.447-.545-1.089-1.57 11.774a1 1 0 0 1-.99.868H7a1 1 0 0 1-.991-.868L4.44 7.36l-.545 1.088a1 1 0 0 1-1.79-.894l1.992-3.982A1 1 0 0 1 5.022 3h13.957a1 1 0 0 1 .916.552l2 4a1 1 0 1 1-1.79.894ZM10 8 7 5h10l-3 3h-4Z", fill: color }));
};
export default factorySvgIcon(SvgTakeawayFilled);
//# sourceMappingURL=SvgTakeawayFilled.js.map